var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    class: _vm.width == true ? '' : 'overflow'
  }, [_c('table', {
    staticClass: "styled-table",
    class: _vm.width == true ? 'extrawidth' : 'widthsize'
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._l((_vm.columns), function(column, index) {
    return (column == 'Select' && _vm.financerole) ? _c('th', {
      key: index,
      staticClass: "text-center"
    }, [_vm._v("Select ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (column == 'Select all' && _vm.financerole) ? _c('th', {
      key: index,
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectall),
        expression: "selectall"
      }],
      staticStyle: {
        "z-index": "1"
      },
      attrs: {
        "type": "checkbox",
        "value": "1",
        "id": "ShipmentDropByClient",
        "name": "ShipmentDropByClient"
      },
      domProps: {
        "checked": Array.isArray(_vm.selectall) ? _vm._i(_vm.selectall, "1") > -1 : (_vm.selectall)
      },
      on: {
        "click": function($event) {
          _vm.action('selectall', 1, $event)
        },
        "__c": function($event) {
          var $$a = _vm.selectall,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "1",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectall = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectall = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectall = $$c
          }
        }
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('th', [_vm._v("Sr.No")]), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (column != 'Action' && column != 'Status' && column != 'FileName' && column != 'Rate Action' && column != 'Select' && column != 'Select all' && column != 'End Date' && column != 'Trip Tags' && column != 'Age (days)' && column != 'Refund' && column != 'IRN Response' && column != 'Download Invoice') ? _c('th', {
      key: index,
      staticClass: "text-left",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_vm._v(_vm._s(column))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (column == 'Action' || column == 'Status' || column == 'FileName' || column == 'End Date' || column == 'Rate Action' || column == 'Trip Tags' || column == 'IRN Response' || column == 'Download Invoice') ? _c('th', {
      key: index,
      staticClass: "text-center"
    }, [_vm._v(_vm._s(column))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (column == 'Age (days)') ? _c('th', {
      key: index,
      staticClass: "text-center"
    }, [_vm._v(_vm._s(column) + " "), (_vm.sorting == 'desc') ? _c('i', {
      staticClass: "fa fa-arrow-down",
      attrs: {
        "aria-hidden": "true",
        "title": "Desc sorting"
      },
      on: {
        "click": function($event) {
          _vm.action('sorting', 'asc')
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.sorting == 'asc') ? _c('i', {
      staticClass: "fa fa-arrow-up",
      attrs: {
        "aria-hidden": "true",
        "title": "Desc sorting"
      },
      on: {
        "click": function($event) {
          _vm.action('sorting', 'desc')
        }
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return (column == 'Refund') ? _c('th', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.disabledflag == true),
        expression: "disabledflag == true"
      }],
      key: index,
      staticClass: "text-center"
    }, [_vm._v(_vm._s(column))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "tbody"
    }
  }, [(!_vm.items || _vm.items.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.columns.length + 1
    }
  }, [_vm._v("No Records Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return [_c('tr', {
      key: index,
      style: (item.FTCRecordsTableFlag != undefined ? item.FTCRecordsTableFlag ? !item.iscompletebooking ? 'opacity: 0.5;' : '' : '' : ''),
      attrs: {
        "disabled": item.FTCRecordsTableFlag != undefined ? item.FTCRecordsTableFlag ? !item.iscompletebooking ? true : false : false : false,
        "id": item.id
      }
    }, [_vm._l((_vm.columns), function(column, indexColumn) {
      return ((column == 'Select' || column == 'Select all') && _vm.financerole) ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.ischecked),
          expression: "item.ischecked"
        }],
        staticStyle: {
          "z-index": "1"
        },
        attrs: {
          "type": "checkbox",
          "value": "1",
          "id": "item.id",
          "name": "indexColumn"
        },
        domProps: {
          "checked": Array.isArray(item.ischecked) ? _vm._i(item.ischecked, "1") > -1 : (item.ischecked)
        },
        on: {
          "click": function($event) {
            _vm.action('select', item.id, $event)
          },
          "__c": function($event) {
            var $$a = item.ischecked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = "1",
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (item.ischecked = $$a.concat($$v))
              } else {
                $$i > -1 && (item.ischecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              item.ischecked = $$c
            }
          }
        }
      })]) : _vm._e()
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.offset + index + 1))]), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Route ID' || column == 'Route Name') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_vm._v(_vm._s(item[column]))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Clients') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_c('span', [_vm._v(_vm._s(item[column][0]))]), _vm._v(" "), (item[column].length > 1) ? _c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Click to open list of Clients"
        },
        on: {
          "click": function($event) {
            _vm.action('viewClient', item.id)
          }
        }
      }, [_vm._v("+" + _vm._s(item[column].length - 1))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'FM Pincodes') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_c('span', [_vm._v(_vm._s(item[column][0]))]), _vm._v(" "), (item[column].length > 1) ? _c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Click to open list of FM Pincodes"
        },
        on: {
          "click": function($event) {
            _vm.action('viewClient', item.id)
          }
        }
      }, [_vm._v("+" + _vm._s(item[column].length - 1))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Trip ID') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_c('span', [_vm._v(_vm._s(item[column]))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'WayBill No') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_c('span', [_vm._v(_vm._s(item[column][0]))]), _vm._v(" "), (item[column].length > 1) ? _c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Click to open list of WayBill No"
        },
        on: {
          "click": function($event) {
            _vm.action('viewWaybill', item.id)
          }
        }
      }, [_vm._v("+" + _vm._s(item[column].length - 1))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'WayBill Number') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_c('span', [_vm._v(_vm._s(item[column][0]))]), _vm._v(" "), (item[column].length > 1) ? _c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Click to open list of WayBill No"
        },
        on: {
          "click": function($event) {
            _vm.action('viewWaybill', item.id)
          }
        }
      }, [_vm._v("+" + _vm._s(item[column].length - 1))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'LM Pincodes') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_c('span', [_vm._v(_vm._s(item[column][0]))]), _vm._v(" "), (item[column].length > 1) ? _c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Click to open list of LM Pincodes"
        },
        on: {
          "click": function($event) {
            _vm.action('viewClient', item.id)
          }
        }
      }, [_vm._v("+" + _vm._s(item[column].length - 1))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column != 'Action' && column != 'Status' && column != 'Select' && column != 'Select all' && column != 'FileName' && column != 'End Date' && column != 'POD' && column != 'POH' && column != 'Actions' && column != 'Rate Action' && column != 'View Images' && column != 'LMMPS' && column != 'FMMPS' && column != 'POP' && column != 'Trip Tags' && column != 'PRAWB' && column != 'AWB List' && column != 'Age (days)' && column != 'Bad POD reason' && column != 'Payment Response' && column != 'Refund' && column != 'Clients' && column != 'FM Pincodes' && column != 'LM Pincodes' && column != 'Route ID' && column != 'Route Name' && column != 'Versions' && column != 'IRN Response' && column != 'Trip ID' && column != 'Download Invoice' && column != 'WayBill No' && column != 'WayBill Number') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_vm._v(_vm._s(item[column]) + "\n            "), (column == 'AWB' && item.count > 1) ? _c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Click to open bad pod count of AWB(partial delivered)"
        },
        on: {
          "click": function($event) {
            _vm.action('viewAWB', index)
          }
        }
      }, [_vm._v("+" + _vm._s(item.count - 1))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'End Date' && _vm.financerole) ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [_c('span', {
        staticClass: "action",
        attrs: {
          "title": "Change Client contract extension date"
        },
        on: {
          "click": function($event) {
            _vm.action('extensiondate', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "common-dth-cross-primary",
        attrs: {
          "type": "End Date"
        }
      }, [_vm._v(_vm._s(item[column]))])])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'End Date' && !_vm.financerole) ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [_c('span', {
        staticClass: "text-left"
      }, [_vm._v(_vm._s(item[column]) + " ")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'FileName') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [_c('span', {
        staticClass: "action",
        attrs: {
          "title": "download"
        },
        on: {
          "click": function($event) {
            _vm.action('download', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true",
          "title": "Download Document"
        }
      })])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Bad POD reason') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left"
      }, [_c('span', {
        staticClass: "helpertooltip"
      }, [_vm._v("\n              " + _vm._s((item[column].length > 30) ? item[column].slice(0, 30 - 1) + '…' : item[column]) + "\n              "), (item[column].length > 30) ? _c('span', {
        staticClass: "helpertooltiptext"
      }, [_vm._v(_vm._s(item[column]))]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Age (days)') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [_vm._v("\n            " + _vm._s(item[column]) + "\n          ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'AWB List') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "2%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View AWB"
        },
        on: {
          "click": function($event) {
            _vm.action('viewawb', item.id)
          }
        }
      }, [_vm._v("View AWB")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'View Images') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View Image"
        },
        on: {
          "click": function($event) {
            _vm.action('viewimage', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-picture-o",
        staticStyle: {
          "font-size": "14px",
          "color": "black"
        }
      }), _vm._v("   ")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'LMMPS') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View MPS"
        },
        on: {
          "click": function($event) {
            _vm.action('viewmps', item.AWB)
          }
        }
      }, [_vm._v("View MPS")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'POD') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.STATUS == 'delivered'),
          expression: "item.STATUS == 'delivered'"
        }],
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View Image"
        },
        on: {
          "click": function($event) {
            _vm.action('viewimage', item.AWB)
          }
        }
      }, [_vm._v("View Image")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'POH') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View uplaoded Proof of handover"
        },
        on: {
          "click": function($event) {
            _vm.action('viewimage', item.index)
          }
        }
      }, [_vm._v("View POH")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'FMMPS') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View MPS"
        },
        on: {
          "click": function($event) {
            _vm.action('viewmps', item.AWB)
          }
        }
      }, [_vm._v("View MPS")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'PRAWB') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View AWB"
        },
        on: {
          "click": function($event) {
            _vm.action('viewawb', item.id)
          }
        }
      }, [_vm._v("View AWB")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'POP') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.STATUS == 'picked'),
          expression: "item.STATUS == 'picked'"
        }],
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View Image"
        },
        on: {
          "click": function($event) {
            _vm.action('viewimage', item.AWB)
          }
        }
      }, [_vm._v("View Image")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Actions') ? _c('td', {
        key: indexColumn,
        staticClass: "text-left",
        attrs: {
          "width": "8%"
        }
      }, [(item.label) ? _c('span', {
        attrs: {
          "title": item.iscompletebooking == true ? '' : 'Please perform complete booking'
        }
      }, [_c('a', {
        class: {
          'enabled': item.iscompletebooking,
          'disabled': !item.iscompletebooking,
          'text-primary': false,
          'badge': true,
          'badge-light': true
        },
        staticStyle: {
          "font-size": "11px"
        },
        style: (item.iscompletebooking ? 'text-decoration: underline;' : ''),
        on: {
          "click": function($event) {
            _vm.action('calculateFtc', item.AWB)
          }
        }
      }, [_vm._v(_vm._s(item.label) + " ")])]) : _vm._e(), _vm._v(" "), (item.label) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', {
        attrs: {
          "title": item.iscompletebooking ? '' : 'Please perform complete booking'
        }
      }, [(item['Cash Memo Generate'] == 'Yes') ? _c('a', {
        class: {
          'enabled': item.iscompletebooking,
          'disabled': !item.iscompletebooking,
          'text-primary': false,
          'badge': true,
          'badge-light': true,
          'mt-1': true
        },
        staticStyle: {
          "font-size": "11px"
        },
        style: (item.iscompletebooking ? 'text-decoration: underline;' : ''),
        on: {
          "click": function($event) {
            _vm.action('cashMemo', item.AWB)
          }
        }
      }, [_vm._v("Cash Memo")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Versions') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View all versions"
        },
        on: {
          "click": function($event) {
            _vm.action('versions', item.id)
          }
        }
      }, [_vm._v("View all versions")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Status') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [(item[column] == 1) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Status"
        },
        on: {
          "click": function($event) {
            _vm.action('active', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "common-success",
        attrs: {
          "type": "button"
        }
      }, [_vm._v("Active")])]) : _vm._e(), _vm._v(" "), (item[column] == 0) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Status"
        },
        on: {
          "click": function($event) {
            _vm.action('inactive', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "common-danger",
        attrs: {
          "type": "button"
        }
      }, [_vm._v("Inactive")])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Trip Tags') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [(item[column][0] == 2) ? _c('span', {
        staticClass: "action,",
        attrs: {
          "title": "This Trip is eligible for DTH"
        },
        on: {
          "click": function($event) {
            _vm.action('triptag', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "common-dth-primary",
        staticStyle: {
          "margin-right": "17px"
        },
        attrs: {
          "type": "button",
          "disabled": item['Trip Status'] == 'Closed' ? true : false
        }
      }, [_vm._v("DTH")])]) : _vm._e(), _vm._v(" "), (item[column][0] == 1) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "This Trip is eligible for DTH"
        },
        on: {
          "click": function($event) {
            _vm.action('closetag', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "common-dth-cross-primary",
        attrs: {
          "type": "button",
          "disabled": item['Trip Status'] == 'Closed' ? true : false
        }
      }, [_vm._v("DTH")]), _vm._v("  ")]) : _vm._e(), (item[column] == 1 && item['Trip Status'] != 'Closed') ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Converting Standered to DTH Trip"
        },
        on: {
          "click": function($event) {
            _vm.action('closetag', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      })]) : _vm._e(), _vm._v(" "), (item[column][0] == 0) ? _c('span', {
        staticClass: "action"
      }) : _vm._e(), _vm._v(" "), (item[column][1] == 2) ? _c('span', {
        staticClass: "action,",
        attrs: {
          "title": "PR"
        },
        on: {
          "click": function($event) {
            _vm.action('approved-pickupright', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "common-dth-primary",
        staticStyle: {
          "margin-right": "17px"
        },
        attrs: {
          "type": "button",
          "disabled": item['Trip Status'] == 'Closed' ? true : false
        }
      }, [_vm._v("PR")])]) : _vm._e(), _vm._v(" "), (item[column][1] == 1) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "PR is pending for your action."
        },
        on: {
          "click": function($event) {
            _vm.action('pending-pickupright', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "common-dth-cross-primary",
        attrs: {
          "type": "button",
          "disabled": item['Trip Status'] == 'Closed' ? true : false
        }
      }, [_vm._v("PR")]), _vm._v("  ")]) : _vm._e(), (item[column] == 1 && item['Trip Status'] != 'Closed') ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Approve Helper request"
        },
        on: {
          "click": function($event) {
            _vm.action('pending-pickupright', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      })]) : _vm._e(), _vm._v(" "), (item[column][1] == 0) ? _c('span', {
        staticClass: "action"
      }) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Action') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center",
        staticStyle: {
          "width": "5rem"
        }
      }, [(!_vm.isEditHidden) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.action('edit', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit",
        staticStyle: {
          "font-size": "14px"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item[column] == 0 || item[column] == 3) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.action('edit', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit",
        staticStyle: {
          "font-size": "14px"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item[column] == 'EDIT') ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.action('edit', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit",
        staticStyle: {
          "font-size": "14px"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (_vm.isApprrove) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Approve"
        },
        on: {
          "click": function($event) {
            _vm.action('approve', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-thumbs-up",
        staticStyle: {
          "font-size": "14px",
          "color": "#2b76b3"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item.isFTCApprov) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Approve"
        },
        on: {
          "click": function($event) {
            _vm.action('approve', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-thumbs-up",
        staticStyle: {
          "font-size": "14px",
          "color": "#2b76b3"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (_vm.isReject) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Reject"
        },
        on: {
          "click": function($event) {
            _vm.action('reject', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-thumbs-down",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item.isFTCReject) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Reject"
        },
        on: {
          "click": function($event) {
            _vm.action('reject', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-thumbs-down",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item.isFTCReverse) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Reverse Approved Deposit"
        },
        on: {
          "click": function($event) {
            _vm.action('reverse', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-repeat",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (!_vm.isViewHidden) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "View"
        },
        on: {
          "click": function($event) {
            _vm.ShowEachDetails(item, item.id)
          }
        }
      }, [_c('img', {
        attrs: {
          "height": "16",
          "width": "16",
          "src": "/static/img/view.png"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (_vm.isViewDetails) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "View Damage Details"
        },
        on: {
          "click": function($event) {
            _vm.ShowEachDetails(item, item.id)
          }
        }
      }, [_c('img', {
        attrs: {
          "height": "16",
          "width": "16",
          "src": "/static/img/view.png"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (_vm.isDelete) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Delete"
        },
        on: {
          "click": function($event) {
            _vm.action('delete', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      })]) : _vm._e(), _vm._v(" "), (item[column] == 'annexure-0' || item[column] == 'annexure-3') ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Delete"
        },
        on: {
          "click": function($event) {
            _vm.action('delete', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.isResync) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Re-Sync"
        },
        on: {
          "click": function($event) {
            _vm.action('resync', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-refresh",
        staticStyle: {
          "font-size": "14px",
          "color": "black"
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.isViewImage) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "View Images"
        },
        on: {
          "click": function($event) {
            _vm.action('isviewimage', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-picture-o",
        staticStyle: {
          "font-size": "14px",
          "color": "black"
        }
      }), _vm._v("   ")]) : _vm._e(), _vm._v(" "), (_vm.isDownloadImage) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Download"
        },
        on: {
          "click": function($event) {
            _vm.action('isdownloadimage', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "14px",
          "color": "black"
        }
      }), _vm._v("   ")]) : _vm._e(), _vm._v(" "), (_vm.isViewLogs) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "View logs"
        },
        on: {
          "click": function($event) {
            _vm.ShowEachDetails(item, item.id, 'viewlogs')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-list",
        staticStyle: {
          "font-size": "14px",
          "color": "black"
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.isReuploadImage) ? _c('span', {
        staticClass: "action",
        style: (item['FM/LM'] == 'FM' || item['POD Status'] == 'No Action Required' ? 'pointer-events: none;color:grey;' : 'color:black;'),
        attrs: {
          "title": "Re-Upload Images"
        },
        on: {
          "click": function($event) {
            _vm.action('isreuploadimage', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-upload",
        staticStyle: {
          "font-size": "14px"
        }
      })]) : _vm._e(), _vm._v(" "), (item.isDeltePRQ) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": item.isDeltePRQtitle
        },
        on: {
          "click": function($event) {
            _vm.action('delete', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      })]) : _vm._e(), _vm._v(" "), (item.isMVRRejected || item.isMVRPending) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "View"
        },
        on: {
          "click": function($event) {
            _vm.ShowEachDetails(item, item.id)
          }
        }
      }, [_c('img', {
        attrs: {
          "height": "16",
          "width": "16",
          "src": "/static/img/view.png"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item.isMVRPending) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Reject"
        },
        on: {
          "click": function($event) {
            _vm.action('close', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close",
        staticStyle: {
          "font-size": "14px",
          "color": "red"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item.isMVRApprove) ? _c('span', {
        staticClass: "action",
        style: (item.istripCreated == true ? 'pointer-events:none;color:grey;' : 'color:black;'),
        attrs: {
          "title": "Create trip of the Req. Id"
        },
        on: {
          "click": function($event) {
            _vm.action('approve', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-truck",
        staticStyle: {
          "font-size": "14px"
        }
      }), _vm._v("  ")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Rate Action') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center"
      }, [(!item[column]) ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.ShowEachDetails(item, item.id, 'editRate')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit",
        staticStyle: {
          "font-size": "14px"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (!item[column] || item[column] == 'no-view') ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "View"
        },
        on: {
          "click": function($event) {
            _vm.ShowEachDetails(item, item.id, 'view')
          }
        }
      }, [_c('img', {
        attrs: {
          "height": "16",
          "width": "16",
          "src": "/static/img/view.png"
        }
      }), _vm._v("  ")]) : _vm._e(), _vm._v(" "), (item[column] && item[column] != 'no-view') ? _c('span', {
        staticClass: "action",
        attrs: {
          "title": "Define Rate"
        },
        on: {
          "click": function($event) {
            _vm.ShowEachDetails(item, item.id, 'defineRate')
          }
        }
      }, [_c('span', {
        staticStyle: {
          "text-decoration": "underline",
          "text-decoration-color": "blue",
          "color": "blue",
          "font-size": "10px"
        }
      }, [_vm._v("Define\n                Rate")])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Payment Response') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View Response"
        },
        on: {
          "click": function($event) {
            _vm.action('response', item.id)
          }
        }
      }, [_vm._v("View Response")])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Refund') ? _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.disabledflag == true),
          expression: "disabledflag == true"
        }],
        key: indexColumn,
        staticClass: "text-center",
        attrs: {
          "width": "8%"
        }
      }, [(item[column] == true) ? _c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Refund"
        },
        on: {
          "click": function($event) {
            _vm.action('refund', item.id)
          }
        }
      }, [_c('button', {
        staticClass: "-btn btn-success",
        attrs: {
          "type": "button"
        }
      }, [_vm._v(" Refund")])]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'IRN Response') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "View Response"
        },
        on: {
          "click": function($event) {
            _vm.action('response', item.id)
          }
        }
      }, [_vm._v(_vm._s(item[column] ? 'View Response' : ""))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.columns), function(column, indexColumn) {
      return (column == 'Download Invoice') ? _c('td', {
        key: indexColumn,
        staticClass: "text-center",
        attrs: {
          "width": "8%"
        }
      }, [_c('span', {
        staticClass: "action",
        staticStyle: {
          "color": "blue"
        },
        attrs: {
          "title": "Download Invoice"
        },
        on: {
          "click": function($event) {
            _vm.action('downloadinvoice', item.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true",
          "title": "Download Document"
        }
      })])]) : _vm._e()
    })], 2), _vm._v(" "), (_vm.opened.includes(item.id)) ? _c('tr', {
      key: 'inner' + index,
      attrs: {
        "id": 'innerTable' + item.id
      }
    }, [(!item.innerTableInfo) ? _c('td', {
      attrs: {
        "colspan": (_vm.columns.length) + 1
      }
    }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (item.innerTableInfo) ? _c('td', {
      attrs: {
        "colspan": (_vm.columns.length) + 1
      }
    }, [_c('div', {
      staticClass: "row inner-block"
    }, [_vm._l((_vm.innerTableHeader), function(column, index) {
      return [_c('div', {
        staticClass: "element-group",
        class: _vm.innerClassColumn
      }, [_c('div', {
        staticClass: "row combine-key-value"
      }, [_c('span', {
        staticClass: "col-12 inner-table-data"
      }, [_c('b', [_vm._v(_vm._s(column) + " : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.innerTableInfo[column]))])])])])]
    })], 2)]) : _vm._e()]) : _vm._e()]
  })], 2)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a07717dc","hasScoped":true}!./src/modules/shared/components/customExpandableTable/customExpandableTable.component.html
// module id = 615
// module chunks = 3